export const CoordinateAttributeName = {
  id: 'ID',
  rpm: 'RPM',
  rssi: 'RSSI',
  transmissionReason: 'Razão Transmissão',
  transmissionReasonId: 'ID Razão Transmissão',
  equipmentSerial: 'Serial',
  equipmentId: 'Equipamento',
  vehicleId: 'Veículo',
  hodometer: 'Hodômetro',
  hourmeter: 'Horímetro',
  ignition: 'Ignição',
  panic: 'Pânico',
  driverId: 'Motorista',
  vehicleTypeId: 'Tipo Veículo',
  antennaFailure: 'Falha Antena',
  gsmJamming: 'Interferência GSM',
  organizationId: 'Organização',
  noteId: 'Nota',
  profileId: 'Perfil',
  routeId: 'Rota',
  speed: 'Velocidade',
  acceleration: 'Aceleração',
  speedBySystem: 'Velocidade Sistema',
  equipmentTemperature: 'Temperatura Equipamento',
  packetCounter: 'Contador Pacote',
  externalPowerSupply: 'Tensão de Alimentação Externa',
  disordered: 'Desordenado',
  vehicleDisabled: 'Veículo Desabilitado',
  gprsSignalQuality: 'Qualidade Sinal GPRS',
  mainVoltage: 'Tensão Principal',
  batteryVoltage: 'Tensão Bateria',
  vehicleBatteryVoltage: 'Tensão Bateria Veículo',
  serverStatus: 'Status Servidor',
  hardwareInformation: 'Informação Hardware',
  softwareInternalRevision: 'Revisão Interna Software',
  counter1: 'Contador #1',
  counter2: 'Contador #2',
  counter3: 'Contador #3',
  dataTerminalMessage: 'Mensagem do Terminal de Dados',
  softwareVersion: 'Versão Software',
  emergencyType: 'Tipo Emergência',
  eventType: 'Tipo Evento',
  alertType: 'Tipo Alerta',
  serialData: 'Dados Serial',
  cell: 'Célula GSM',
  mode: 'Modo',
  realTime: 'Tempo Real',
  lowBatteryVoltage: 'Baixa Tensão Bateria',
  highTemperatureSensor: 'Sensor Alta Temperatura',
  frozenGps: 'GPS Congelado',
  accelPosition: 'Posição Acelerador',
  fuelLevel: 'Nível Combustível',
  engineTemperature: 'Temperatura Motor',
  fuelFlow: 'Fluxo Combustível',
  secondaryHodometer: 'Hodômetro Secundário',
  airPressure: 'Pressão Ar',
  fuelEconomy: 'Economia de Combustível',
  totalEngineHour: 'Horas Totais Motor',
  engineBrake: 'Freio Motor',
  engineFailure: 'Falha Motor',
  brakeStatus: 'Status Freio',
  countryCode: 'Código País',
  channel: 'Canal',
  cellId: 'ID Célula GSM',
  baseStationId: 'ID Estação Base',
  lac: 'LAC',
  mnc: 'MNC'
};



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/model/coordinate-attribute-name.ts